import axios, {AxiosError, AxiosResponse} from "axios";
import {addCommentsUrl, getAdsUrl, getCommentsUrl, viewAlbumUrl} from "../helpers/UrlHelper";
import {AdsItem, AlbumResponse, CommentItem, ServiceError} from "../models/responses";
import _ from "lodash";
import {MediaAlbumResult} from "./media-album-types";

export function getAlbumInfo(link: string, lockCode?: string): MediaAlbumResult<void> {
    return (dispatch, getState) => {
        axios.get(viewAlbumUrl(link, lockCode || ""))
            .then((response: AxiosResponse<AlbumResponse>) => {
                dispatch({
                    type: `ALBUM_INFO_RECEIVED`,
                    payload: {
                        ...response.data
                    }
                })
                dispatch(getAds(response.data.album_info.id))
            }).catch((error: AxiosError<ServiceError>) => {
            if (error.response?.data.code === "album_locked") {
                dispatch({type: "ALBUM_IS_LOCKED"})
            }
        })

    }
}

export function getAds(albumId: number): MediaAlbumResult<void> {
    return (dispatch, getState) => {
        axios.get(getAdsUrl(albumId))
            .then((response: AxiosResponse<AdsItem[]>) => {
                dispatch({
                    type: "ADS_INFO_RECEIVED",
                    payload: response.data
                })
            }).catch((e) => {
            console.error(e)
        })
    }

}

export function getCommentsForItem(itemId:number): MediaAlbumResult<void> {
    return (dispatch, getState) => {
        axios.get(getCommentsUrl(itemId))
            .then((response: AxiosResponse<CommentItem[]>) => {
                dispatch({
                    type: "COMMENTS_RECEIVED",
                    payload: response.data,
                    itemId: itemId
                })
            }).catch((e) => {
                console.error(e)
        })
    }
}

export function publishComment(itemId: number, message: string): MediaAlbumResult<void> {
    return (dispatch, getState) => {
        axios.post(addCommentsUrl,{
                "item_id": itemId,
                "message": message
            })
            .then((response: AxiosResponse<CommentItem>) => {
                let oldComments = getState().albumState.media.find(s => s.id === itemId)?.comments || [];

                dispatch({
                    type: "COMMENTS_RECEIVED",
                    payload: [...oldComments, response.data],
                    itemId: itemId
                })
            }).catch((e) => {
            console.error(e)
        })
    }
}